import React from "react";
import { ArrowRight } from "lucide-react";
import { FINAL, BRAND } from "../mock";
import Reveal from "./Reveal";

const FinalCTA = () => {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="absolute inset-0 grid-noise opacity-[0.2] -z-10" />
      <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
        <Reveal>
          <div className="relative rounded-3xl border border-[#29354A] bg-[#0A1220] p-10 lg:p-16 overflow-hidden">
            <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-72 h-72 bg-[#10C98A]/12 blur-3xl rounded-full" />
            <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
              {FINAL.headline}
            </h2>
            <p className="mt-5 text-lg text-[#8290A8] max-w-xl mx-auto">{FINAL.copy}</p>
            <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
              <a href="#beta" className="btn-emerald inline-flex items-center justify-center gap-2 bg-[#10C98A] text-[#050A12] font-semibold px-7 py-4 rounded-full">
                {FINAL.primary} <ArrowRight className="w-5 h-5" />
              </a>
              <a href="#how-it-works" className="inline-flex items-center justify-center border border-[#29354A] hover:border-[#10C98A]/60 text-[#F5F7FB] font-semibold px-7 py-4 rounded-full transition-colors">
                {FINAL.secondary}
              </a>
            </div>
            <p className="mt-8 font-display text-[#13D99A] font-semibold">{BRAND.tagline}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default FinalCTA;
